import type {
  RefreshTokenData,
  CredentialsData,
  ThirdPartyData,
} from '../../repositories/authRepository';

export default class AuthDataProvider {
  static credentials(
    email: string,
    password: string,
    cloudflareToken: string
  ): CredentialsData {
    return {
      username: email,
      password,
      cloudflareToken,
      grant_type: 'password',
    };
  }

  static refreshToken(token: string): RefreshTokenData {
    return {
      grant_type: 'refresh_token',
      refresh_token: token,
    };
  }

  static google(tokenId: string): ThirdPartyData {
    return {
      token: tokenId,
      grant_type: 'urn:mmj-sauth',
      provider: 'google',
    };
  }

  static facebook(accessToken: string): ThirdPartyData {
    return {
      token: accessToken,
      grant_type: 'urn:mmj-sauth',
      provider: 'facebook',
    };
  }
}
